<template>
  <div class="page-header clear-filter" filter-color="orange">
    <div class="page-header-image" :style="backgroundLogin"></div>
    <div class="content">
      <form>
        <div class="container">
          <div class="col-md-5 ml-auto mr-auto">
            <card type="login" plain>
              <div slot="header" class="content-top brand">
                <h2 class="h2-seo" style="color: white">Confirmação</h2>
              </div>

              <p class="lead" style="color: white">{{ msgTxt }}</p>
            </card>
          </div>
        </div>
      </form>
    </div>
    <main-footer></main-footer>
  </div>
</template>

<script lang="js">
import { Card } from '@/components';
import MainFooter from '@/layout/MainFooter';
import { userService } from '@/_services';

export default {
  name: 'confirm-page',
  bodyClass: 'register-page',
  components: {
    Card,
    MainFooter,
  },
  data() {
    return {
      backgroundLogin: "background-image: url('img/trevo.jpg')",
      msgTxt : 'Aguarde, verificando as informações de registro ...'
    }
  },
  methods:{

  },
  mounted() {
    if (window.config && window.config.SIGLA_ASSETS) {
      const siglaAssets = window.config.SIGLA_ASSETS;
      this.backgroundLogin = `background-image: url('/img/${siglaAssets}/trevo.jpg')`;
    }

    const userId = this.$route.params.id;

    userService.registerConfirm({nome: userId}, userId).then(
      () => {
        this.msgTxt = 'Usuário registrado com sucesso.';
        this.$notify({
          group: 'msgs',
          title: 'Registro',
          text: 'Usuário registrado com sucesso.',
          type: 'info'
        });

        this.$router.push('/')
      },
      error => {
        this.msgTxt = error;
        this.$notify({
            group: 'msgs',
            title: 'Erro',
            text: error,
            type: 'error'
          });
        }
    );

  }
}
</script>
